import { createTdWithElement, createTdWithText, createImg, createTableBodyLoadingIndicator, createCheckedIcon } from "../DomUtilities/ElementsCreator";
import { insertBody } from "../DomUtilities/ElementsUtil";
import TablePaginator from "../Pagination/TablePaginator";
import ITableSort from "../Sorting/ITableSort";
import ITablePaginator from "../Pagination/ITablePaginator";
import TableSort from "../Sorting/TableSort";
import ItemBaseModal from "./ItemBaseModal";
import ItemCategory from "../Models/ViewModels/ItemCategory";
import { fetchItemsList } from "../HTTPRequests/ItemRequests";
import PageModel from "../Models/ViewModels/PageModel";
import openErrorModal from "../Error/ErrorModal";
import CreateItemModal from "./CreateItemModal";
import UpdateItemModal from "./UpdateItemModal";
import DisplayOrderModal from "./DisplayOrderModal";
import Mediator from "../Utilities/Mediator";
import ServicesDisplayOrderModal from "./ServicesDisplayOrderModal";

export default class Items implements ITableSort, ITablePaginator {
	table: HTMLElement;
	searchBar: HTMLInputElement;
	paginator: TablePaginator;
	createBtn: HTMLButtonElement;
	modal: ItemBaseModal;
	sortHandler: TableSort;

	constructor() {
		this.table = document.getElementById('items');
		this.searchBar = document.querySelector('input.search-bar');
		this.createBtn = document.querySelector('.create-btn');
		this.paginator = new TablePaginator(this);
		this.sortHandler = new TableSort(this);

		this.init();
	}

	private init(): void {
		Mediator.on("itemCrudOperationFinished", () => this.fetchList());
		this.fetchList();
		this.addSearchInputListener();
		this.sortHandler.addSortingIconsClickListeners();
		this.paginator.addPaginationEventsListeners();
		new CreateItemModal(this.createBtn).addCreateModalClickListener();
		new DisplayOrderModal().addDisplayOrderIconClickListener();
	}

	public fetchList() {
		this.showLoadingIndicator();
		fetchItemsList(this.SearchValue, this.sortHandler.sortValue, this.sortHandler.sortAscending, this.paginator.currentPage, this.paginator.pageSize)
			.then((response: PageModel<ItemCategory>) => {
				this.updateTable(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			});
	}

	private showLoadingIndicator() {
		insertBody(this.table, createTableBodyLoadingIndicator());
	}

	private updateTable(data: PageModel<ItemCategory>) {
		this.paginator.currentPage = data.pageNumber;
		this.paginator.total = data.total;
		this.paginator.pageSize = data.pageSize;
		this.renderTable(data.list);
		new UpdateItemModal().addUpdateModalsClickListeners();
	}

	private renderTable(list: Array<ItemCategory>) {
		insertBody(this.table, this.renderBody(list));
		this.paginator.renderFoot();
	}

	private renderBody(itemList: Array<ItemCategory>) {
		const tbody = document.createElement('tbody');
		if (itemList.length) {
			for (let i = 0; i < itemList.length; i++) {
				const tr = document.createElement('tr');
				const imgEdit = createImg('/assets/edit.svg', 'edit icon');
				const imgSortServices = document.createElement('i');

				tr.classList.add('table__row', 'item-row');
				tr.id = itemList[i].id;
				tr.dataset.itemId = itemList[i].id;
				imgSortServices.classList.add('icon-sort-by-attributes');
				imgSortServices.title = "Sorter ydelser";

				let src: string;
				if (itemList[i].image) {
					src = itemList[i].image;
				} else {
					src = "/assets/no_image_placeholder.png";
				}

				const itemImage = createImg(src, `${itemList[i].name} ikon`);
				const arrowIcon = document.createElement('i');
				const tooltip = document.createElement('div');
				const tdName = createTdWithText(itemList[i].name);
				const td = document.createElement('td');

				arrowIcon.classList.add("icon-caret-down");
				tooltip.appendChild(itemImage);
				tooltip.appendChild(arrowIcon);
				tdName.appendChild(tooltip);
				tr.append(tdName);

				const tdSubItems = document.createElement('td');
				if (itemList[i].hasSubItems) {
					tdSubItems.appendChild(createCheckedIcon());
				}

				const tdFastTrack = document.createElement('td');
				if (itemList[i].isFastTrack) {
					tdFastTrack.appendChild(createCheckedIcon());
				}

				const tdSimpleOrderFlow = document.createElement('td');
				if (itemList[i].hasSimpleOrderFlow) {
					tdSimpleOrderFlow.appendChild(createCheckedIcon());
				}

				tr.append(tdSubItems);
				tr.append(tdFastTrack);
				tr.append(tdSimpleOrderFlow);
				tr.append(td);

				if (itemList[i].hasServices) {
					tr.append(createTdWithElement(imgSortServices, imgEdit));
					new ServicesDisplayOrderModal(itemList[i].id, imgSortServices);
				} else {
					tr.append(createTdWithElement(imgEdit));
				}

				tbody.append(tr);
			}
		} else {
			const emptyText = this.table.dataset.empty;
			const tr = document.createElement('tr');
			const td = createTdWithText(emptyText);
			td.colSpan = this.table.querySelectorAll('th').length;
			td.style.textAlign = 'center';
			tr.append(td);
			tbody.append(tr);
		}

		return tbody;
	}

	private get SearchValue() {
		return this.searchBar.value ? this.searchBar.value : "";
	}

	private addSearchInputListener() {
		this.searchBar.oninput = () => {
			this.fetchList();
		}
	}
}
